import { Paper, Stack, Typography } from '@mui/material';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import { useTranslation } from 'react-i18next';

export default function ComingSoonInfo() {
  const { t } = useTranslation();

  return (
    <Paper
      component={Stack}
      elevation={4}
      direction='row'
      sx={{ paddingX: { xs: 2 }, paddingY: { xs: 1.5 } }}
      gap={2}
    >
      <HourglassEmptyOutlinedIcon fontSize='medium' color='primary' />
      <Stack
        direction='column'
        sx={{
          gap: 0.5,
        }}
      >
        <Typography variant='subtitle2'>
          {t('articleComingSoon.title')}
        </Typography>
        <Typography
          variant='body2'
          sx={{
            color: 'text.secondary',
          }}
        >
          {t('articleComingSoon.description')}
        </Typography>
      </Stack>
    </Paper>
  );
}
